import { render, staticRenderFns } from "./PageSearcher.vue?vue&type=template&id=770b4b2c&scoped=true"
import script from "./PageSearcher.vue?vue&type=script&lang=js"
export * from "./PageSearcher.vue?vue&type=script&lang=js"
import style0 from "./PageSearcher.vue?vue&type=style&index=0&id=770b4b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770b4b2c",
  null
  
)

export default component.exports